import React from "react";
import PropTypes from "prop-types";
import {useT} from "../i18n/i18n";

function ServiceIcon({ index = 0 }) {
  const icons = [
    // Consulenza Tecnica - briefcase
    <svg key="0" viewBox="0 0 24 24" className="w-12 h-12" aria-hidden="true">
      <rect x="2" y="7" width="20" height="13" rx="2" fill="none" stroke="currentColor" strokeWidth="2"/>
      <path d="M6 7V5a2 2 0 012-2h8a2 2 0 012 2v2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>,
    // Full-Stack - layers
    <svg key="1" viewBox="0 0 24 24" className="w-12 h-12" aria-hidden="true">
      <path d="M12 2l9 5v4l-9 5-9-5V7l9-5z" fill="none" stroke="currentColor" strokeWidth="2"/>
      <path d="M3 12v4l9 5 9-5v-4" fill="none" stroke="currentColor" strokeWidth="2"/>
      <path d="M3 20v2l9 5 9-5v-2" fill="none" stroke="currentColor" strokeWidth="2"/>
    </svg>,
    // Backend - server/code
    <svg key="2" viewBox="0 0 24 24" className="w-12 h-12" aria-hidden="true">
      <rect x="2" y="3" width="20" height="8" rx="1" fill="none" stroke="currentColor" strokeWidth="2"/>
      <rect x="2" y="14" width="20" height="7" rx="1" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="6" cy="7" r="1" fill="currentColor"/>
      <circle cx="6" cy="18" r="1" fill="currentColor"/>
    </svg>,
    // Frontend - palette
    <svg key="3" viewBox="0 0 24 24" className="w-12 h-12" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="12" cy="5" r="2" fill="currentColor"/>
      <circle cx="17" cy="9" r="2" fill="currentColor"/>
      <circle cx="17" cy="15" r="2" fill="currentColor"/>
      <circle cx="12" cy="19" r="2" fill="currentColor"/>
      <circle cx="7" cy="15" r="2" fill="currentColor"/>
      <circle cx="7" cy="9" r="2" fill="currentColor"/>
    </svg>,
  ];
  
  return icons[index] || icons[0];
}

ServiceIcon.propTypes = { index: PropTypes.number };

function CheckIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M5 12l5 5L19 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

CheckIcon.propTypes = { className: PropTypes.string };

export default function Services({language}) {
    const {t, tArray} = useT(language);
    const serviceItems = tArray("services.items");

    return (
        <section className="py-16 sm:py-20 w-full">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                {/* Header */}
                <div className="mb-14 text-center sm:text-left">
                    <p className="text-xs font-semibold uppercase tracking-widest text-[#E19F3B] mb-3">
                        OFFERTA DI SERVIZI
                    </p>
                    <h2 className="text-3xl sm:text-4xl font-bold mb-4 leading-tight text-black">
                        {t("services.title")}
                    </h2>
                    <p className="text-base text-black/70 leading-relaxed max-w-2xl">
                        {t("services.description")}
                    </p>
                </div>

                {/* Services Grid - 4 columns matching design */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {serviceItems && serviceItems.map((service, idx) => (
                        <div 
                            key={idx} 
                            className="flex flex-col p-6 rounded-xl border border-gray-300 hover:shadow-md hover:border-gray-400 transition-all duration-300 bg-white"
                        >
                            {/* Service Name */}
                            <h3 className="text-sm font-semibold mb-3 text-black leading-snug">
                                {service.name}
                            </h3>

                            {/* Description */}
                            <p className="text-sm text-black/70 leading-relaxed mb-4 flex-grow">
                                {service.description}
                            </p>
                            
                            {/* Details List */}
                            {service.details && service.details.length > 0 && (
                                <ul className="space-y-2.5">
                                    {service.details.map((detail, detailIdx) => (
                                        <li 
                                            key={detailIdx}
                                            className="flex items-start gap-2.5 text-xs text-black/70 leading-relaxed"
                                        >
                                            <CheckIcon className="h-4 w-4 text-[#E19F3B] flex-shrink-0 mt-1" />
                                            <span>{detail}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}


                        </div>
                    ))}
                </div>

                {/* CTA */}
                <div className="mt-12 text-center">
                    <a 
                        href="/#contacts"
                        className="inline-flex items-center gap-2 px-6 py-3 bg-[#E19F3B] text-white font-semibold text-sm rounded-lg hover:bg-[#D68A2B] transition-colors duration-200"
                    >
                        {language === "it" ? "Inizia il Tuo Progetto" : "Start Your Project"}
                    </a>
                </div>
            </div>
        </section>
    );
}

Services.propTypes = {
    language: PropTypes.oneOf(["en", "it"]),
};